// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContainer_root__JzI6Q","wrapper":"PageContainer_wrapper__v0JL_"};